<main class="dialog-wrapper">
  <h2 mat-dialog-title i18n>{{data.title}}</h2>
  <section mat-dialog-content>
    <p [innerHTML]="data.description"></p>
  </section>
  <section class="button-wrapper" mat-dialog-actions>
    <button mat-flat-button i18n (click)="submit($event)">Doorgaan</button>
  </section>
</main>